<script setup>
import { useLinks } from '../../links';

const { getSocial } = useLinks();
</script>

<template>
    <div class="d-flex justify-content-center justify-content-lg-between align-items-center gap-4 flex-column flex-lg-row">
                <div>
                    
                </div>

                <div class="d-flex gap-4">
                    <a v-if="getSocial('instagram')" :href="getSocial('instagram')" target="_blank" rel="nofollow">
                        <font-awesome-icon class="fs-4" :icon="['fab', 'instagram']" />
                    </a>
                    <a v-if="getSocial('facebook')" :href="getSocial('facebook')" target="_blank">
                        <font-awesome-icon class="fs-4" :icon="['fab', 'facebook']" />
                    </a>
                    <a v-if="getSocial('linkedin')" :href="getSocial('linkedin')" target="_blank">
                        <font-awesome-icon class="fs-4" :icon="['fab', 'linkedin']" />
                    </a>
                </div>
            </div>
</template>